module.exports = __webpack_public_path__ + "img/ic_loading.3a4d4ac1.svg";